import { Box, Modal, Typography } from "@mui/material";
import Input from "../Common/Input";
import Button from "../Common/Button";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { closeDialogue } from "../../util/Dialogue";
import { useParams } from "react-router-dom";
import {
  addOrgDepartment,
  updateOrgDepartment,
} from "../../store/organizationUser/organizationUser.action";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  borderRadius: "13px",
  border: "1px solid #C9C9C9",
  boxShadow: 24,
  p: "19px",
};

const CreateOrgDepartments = () => {
  const dispatch = useDispatch();
  const { departments } = useSelector((state) => state.organizationUser);
  const { dialogue, dialogueData } = useSelector((state) => state.dialogue);
  const { orgId } = useParams();

  const [name, setName] = useState("");
  const [description, setDescription] = useState("");

  const [errors, setError] = useState({
    name: "",
    description: "",
  });

  useEffect(() => {
    if (dialogueData) {
      setName(dialogueData.name);
      setDescription(dialogueData.description || "");
    }
  }, [dialogueData]);

  const closePopup = () => {
    resetForm();
    closeDialogue(dispatch);
  };

  const handleSubmit = () => {
    if (!name) {
      let error = {};
      if (!name) error.name = "Department name is required!";

      return setError({ ...error });
    } else {
      const payload = {
        name,
        description,
        organizationId: orgId,
      };

      if (dialogueData) {
        console.log("UPDATE DEPARTMENT ", payload);
        dispatch(updateOrgDepartment(dialogueData._id, payload));
      } else {
        console.log("CREATE DEPARTMENT ", payload);
        dispatch(addOrgDepartment(payload));
      }

      closePopup();
    }
  };

  const resetForm = () => {
    setName("");
    setDescription("");
    setError({
      name: "",
      description: "",
    });
  };

  return (
    <Modal
      open={dialogue}
      onClose={closePopup}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style} className="create-department-model create-modal">
        <Typography id="modal-modal-title" variant="h6" component="h2">
          {dialogueData ? "Edit Department" : "Add Department"}
        </Typography>
        <form>
          <div className="row row-gap-4">
            <div className="col-12">
              <Input
                label={"Department Name"}
                name={"name"}
                type={"text"}
                placeholder={"Enter Department Name.."}
                errorMessage={errors.name && errors.name}
                value={name}
                onChange={(e) => {
                  setName(e.target.value);

                  if (!e.target.value) {
                    return setError({
                      ...errors,
                      name: "Department name can't be blank!",
                    });
                  } else {
                    return setError({
                      ...errors,
                      name: "",
                    });
                  }
                }}
              />
            </div>

            <div className="col-12 border-top pt-3">
              {departments.length ? (
                <Typography className="fw-medium">Departments</Typography>
              ) : null}
              <div
                className="col-12 pt-4 d-flex flex-wrap row-gap-4"
                style={{ maxHeight: "200px", overflow: "auto" }}
              >
                {departments.map((dept) => (
                  <div key={dept._id} className={`px-4 border-end`}>
                    <span>{dept.name}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="mt-3 d-flex justify-content-end gap-2">
            <Button type={"button"} className={"close"} onClick={closePopup}>
              Cancel
            </Button>
            <Button type={"button"} onClick={handleSubmit} className={"submit"}>
              {dialogueData ? "Update" : "Submit"}
            </Button>
          </div>
        </form>
      </Box>
    </Modal>
  );
};

export default CreateOrgDepartments;
